const utils = require('frontend-controller/lib/utils');
const ClientError = require('frontend-controller/client/error')

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: false,
		supportLazyloading: false,
		// lazyloadStepSize: 25,
		// preventSortOfField: {
		// 	tags: true
		// },
		buttonContext: 'timeRecordings',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		// rowActionsProperties: {
		// 	colWidth: '315px',
		// 	colSpan: 1,
		// 	rowSpan: 2
		// },
		// customColActionsFile: 'templates/newsletter/mailings/table/customColActions',

		// rowActions: {
		// 	delete: true,
		// 	edit: true,
		// 	customs: [{
		// 		buttonType: 'showDuplicate',
		// 		buttonContext: 'mailing'
		// 	}]
		// },
	},

	model: {
		// these button params control the behaviour of the gui. they will be provided via resourceRegister and combine all options within one place.
		// this is helpful because this table may be opened by 4 different viewer- and 2 different shippingOrderTable-buttons.
		buttonParams: {
			// baseContext, // 'timeRecordings'
			// buttonContext, // 'timeRecordings', 'timeRecordings_projectTerm'
			// buttonMode, // 'timeRegistration', 'shippingOrder'
			// projectID,
			// projectTermID,
			// projectTermJobID,
			// origin, // 'viewer', true
			// returnOnUserDecisionPromise, // not used within this component. this boolean flag decides if the showEdit has to block until the user has trigger the onDecision submit for workflow purposes.
		},
		showProjectTermFields: false, // since this table will be used for all kinds of timeRecordings (shippingOrders as well as timeRegistrations at the moment) this flag decides if the projectTermFields should be shown or not.
		projectTermFields: {}, // each projectTerm within timeRegistrations may get set additional data (e.g., like catering) by the user via groupRow-toggle. initially set by onResourceSanitized()
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
			resourceFilters = resourceFilters || {}
			const resourceRegister = this.getResourceRegisterContent('timeRecordingsTable') || {}
			const parentResourceFilters = resourceRegister.resourceFilters || {}
			utils.refReplace(resourceFilters, parentResourceFilters)

			const buttonParams = this.model.buttonParams = resourceRegister.buttonParams || {}
			this.model.showProjectTermFields = buttonParams.buttonMode === 'timeRegistration'
		},

		sanitizeEntity: function(refEntity, refPrevEntity){
			refEntity.attributes = refEntity.attributes || {}
			refEntity.attributes.name = refEntity.attributes.employeeName
			if(refEntity.attributes.contractorName){
				// TODO: SU symbol?
				refEntity.attributes.name = `SU: ${refEntity.attributes.contractorName}`
			}

			refEntity.attributes.startTime = utils.moment(refEntity.attributes.startTS).format('HH:mm')
			refEntity.attributes.endTime = utils.moment(refEntity.attributes.endTS).format('HH:mm')
			refEntity.attributes.showTS = ((refEntity.meta || {}).term || {}).startTS
			refEntity.attributes.title = ((refEntity.meta || {}).term || {}).title
		},

		addEntity: function(entity, prevEntity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				// add group line if necessary
				if(!prevEntity || ((entity.attributes || {}).date && (prevEntity.attributes || {}).date && entity.attributes.date != prevEntity.attributes.date)){
					this.model.$table.append(this.include('./groupRow', { config: this.config, resourceData: entity, model: this.model }));
				}

				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		onResourceSanitized(){
			// prepare projectTermFields
			const projectTermFields = this.model.projectTermFields = {}
			for(const job of Object.values(this.resourceData.data || {})){
				const term = (job.meta || {}).term || {}
				if(term.projectTermID) {
					if(!projectTermFields[term.projectTermID]){
						projectTermFields[term.projectTermID] = {
							catering: !!term.catering,
						}
					}
				}
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				var baseActionName = 'showEdit_timeRecord'
				this.performAndStoreAction(
					`${baseActionName}_inEffect`,
					this.prepareAction(baseActionName, undefined, {
						timeRecordProperties: {
							data: rowData
						}
					})
				);
			}
		},

		async onBeforeRender(){
			if(!storage.isClient) return;
			if(utils.collectionSize(this.resourceData.data) > 0) return;


			// empty data can either mean that the actual employee has insufficient permissions or that all available (according to the employees permissions) projectTerms already have got assigned a shippingOrder.
			let controller
			this.closest('base_modal_modal', modal => modal.hide())
			this.closest('templates_core_controller_controller', c => controller = c)

			// TODO: 	proper error handling is not possible at the moment since onBeforeRender will not be awaited or could even abort anything.
			// 			take a look at global client-side error handling.
			if(!controller) throw new ClientError('CREW_TIME_RECORDINGS_EMPTY_ENTRIES_CONTROLLER_MISSING');



			let timeRecordingsScope = 'all'
			if(this.model.buttonParams.projectTermID){
				timeRecordingsScope = 'projectTerm'
			}

			const projectMeta = (this.resourceData.meta || {}).project || {}
			const {
				editDeniedReason,
				termsEditDeniedReasonSummary,
				editGrantedTermsFound,
			} = projectMeta

			if(editDeniedReason){
				return controller.performAction(
					controller.prepareAction('message', undefined, {
						messageDisplay: {
							message: `table.timeRecordings.gotNoData.${timeRecordingsScope}.${this.model.buttonParams.buttonMode}.byProjectEditDeniedReason.${editDeniedReason}`,
						},
					})
				)
			}

			for(const [reason, nrOfElements] of Object.entries(termsEditDeniedReasonSummary || {})){
				if(reason !== 'NONE'){
					return controller.performAction(
						controller.prepareAction('message', undefined, {
							messageDisplay: {
								message: `table.timeRecordings.gotNoData.${timeRecordingsScope}.${this.model.buttonParams.buttonMode}.byProjectTermEditDeniedReason.${reason}`,
								variables: {
									nrOfElements,
								},
							},
						})
					)
				}
			}

			if(!editGrantedTermsFound){
				return controller.performAction(
					controller.prepareAction('message', undefined, {
						messageDisplay: {
							message: `table.timeRecordings.gotNoData.${timeRecordingsScope}.${this.model.buttonParams.buttonMode}.missingProjectTerms`,
						},
					})
				)
			}

			return controller.performAction(
				controller.prepareAction('message', undefined, {
					messageDisplay: {
						message: `table.timeRecordings.gotNoData.${timeRecordingsScope}.${this.model.buttonParams.buttonMode}.all`,
					},
				})
			)
		},
	},

	hooks: {
		setAllTimeRecordsField: function($element, options){
			if(options.fieldValue && (options.fieldCode === 'startTS' || options.fieldCode === 'endTS')){
				for(var e in this.model.entityList){
					const entity 		= this.model.entityList[e] || {}
					const attributes 	= entity.attributes || {}
					const field 		= attributes[options.fieldCode]
					const termField 	= ((entity.meta || {}).term || {})[options.fieldCode]

					if(termField || field){
						attributes[options.fieldCode] = utils.moment(`${utils.moment(termField || field).format('YYYY-MM-DD')}T${options.fieldValue}:00.000`).format()
					}

					if(attributes.startTS && attributes.endTS){
						const mFrom = utils.moment(attributes.startTS)
						const mTo = utils.moment(attributes.endTS)
						attributes.duration = mTo.diff(mFrom, 'hours', true)
						if(attributes.duration > 24 || attributes.duration <= 0){
							const toIsAtNextDay = mTo.format(utils.moment.HTML5_FMT.TIME_MS) <= mFrom.format(utils.moment.HTML5_FMT.TIME_MS)
							mTo.set({
								year: mFrom.year(),
								month: mFrom.month(),
								date: mFrom.date(),
								hour: mTo.hour(),
								minute: mTo.minute(),
								second: mTo.second(),
								millisecond: mTo.millisecond(),
							})
							if(toIsAtNextDay){
								mTo.add(1, 'day')
							}
							attributes.duration = Math.abs(mTo.diff(mFrom, 'hours', true))
							attributes.endTS = mTo.format()
						}
					} else {
						attributes.duration = 0
					}
				}

				this.refresh(false)
			}
		},

		onDecision: function($element, options){
			if(options.decisionComponent && options.decisionComponent.hasClass('base_modal_modal')){
				switch(options.decisionType){
					case 'submit':
						const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
						// get data of changed timeRecord
						if(modalContentComponent.hasClass('templates_crew_timeRecordings_recordPropertiesForm_recordPropertiesForm')){
							const dirtyFields = modalContentComponent.model.dirtyFields || {}
							const primaryKey = ((dirtyFields.data || {}).attributes || {}).projectTermJobID
							const entityKey = `entityID_${primaryKey}`
							// console.log('replace data in table', data)
							if(primaryKey && this.model.entityList[entityKey]){
								utils.refReplace(this.model.entityList[entityKey].attributes, dirtyFields.data.attributes)
								this.refresh(false)
							}

							// hide modal
							options.decisionComponent.hide();
						}

						break;

					case 'cancel':
					default:
						// hide modal
						options.decisionComponent.hide();
						break;
				}
			}
		},

		onChildChanged: function($element, options){
			if(this.model.buttonParams.buttonMode === 'timeRegistration'){
				const fieldCodeParts = String(options.fieldCode || '').split('_')
				const fieldCode = fieldCodeParts[0]
				const projectTermID = fieldCodeParts[1]

				if(fieldCode === 'catering' && this.model.projectTermFields[projectTermID || -1]){
					this.model.projectTermFields[projectTermID].catering = options.value === 1
				}
			}
		}
	},
}
